<template>

    <div id="login">
        <img class="logo" alt="Lewis Rice" src="../assets/images/lewis-rice-logo-white.svg">
        <h1>Estate Planning Document Portal</h1>
        <div v-if="loginHelpStep==''">
            <div class="form-group">
                <input type="text" name="username" v-model:username="username" placeholder="email">
            </div>
            <div class="form-group">
                <input type="password" name="password" v-model:password="password" placeholder="password">
            </div>
            <div class="form-group">
                <button class="btn btn-lg btn-primary" type="submit" @click="requestLogin">login</button>
            </div>
            <div>
                <p><a href="#" @click="setLoginHelpStep('reset-password')">Need help logging in?</a></p>
            </div>
        </div>
        <div v-if="loginHelpStep=='reset-password'" class="get-login-help">
            <h4>Enter your account email below to receive instructions for resetting your login credentials.</h4>
            <div class="form-group">
                <input type="text" name="username" v-model:username="username" placeholder="email">
            </div>
            <div class="form-group">
                <button class="btn btn-lg btn-default" type="submit" @click="requestPasswordReset">reset password</button>
            </div>
            <div>
                <p><a href="#" @click="setLoginHelpStep('')">Back to login</a></p>
            </div>
        </div>
        <div v-if="loginHelpStep=='email-sent'" class="get-login-help">
            <h2>Please check your email.</h2>
            <h4>You should receive a message containing a link to reset your password.</h4>
            <div>
                <p><a href="#" @click="setLoginHelpStep('')">Back to login</a></p>
            </div>
        </div>
    </div>

</template>



<script>

    import { Store } from '@/store.js'
    import UserService from '@/services/user.service'
    import APIService from '@/services/api.service'
    import router from '@/router'

    export default {
        name: 'login',
        data() {
            return {
                store: Store,
                username: '',//'client_1@example.com',
                password: '',//'tpiPPP!@#$1234',
                loginHelpStep: ''
            }
        },

        methods: {

            hashCredentials: function() {
                return 'Basic ' + btoa(this.username + ':' + this.password)
            },

            requestLogin: function() {
                UserService.authenticate(this.username, this.password)
                    .then(use.bind(this))
                    .catch(failure.bind(this));

                function use(userData) {
                    if (this.$route.query.redirect) {
                        router.push(this.$route.query.redirect)
                    } else {
                        router.push('/')
                    }
                }

                function failure(xhr) {
                    this.password = ''
                }
            },

            requestPasswordReset: function() {
                UserService.forgotPassword(this.username)
                    .then(use.bind(this));

                    function use(data) {
                        this.setLoginHelpStep('email-sent');
                    }

            },

            setLoginHelpStep: function(step) {
                APIService.resetErrors()
                this.loginHelpStep = step
            }
        }
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    #login {

        input {
            padding: .5em;
            background-color: #eee;
            border: 2px dotted #ddd;
        }

        .logo {
            display: inline-block;
            margin: 2rem 0 0 0;
            width: 70%;
            height: auto;
            max-width: 400px;
        }

        h1 {
            text-transform: uppercase;
            font-size: 1.2rem;
            letter-spacing: 0.3em;
            color: #999;
            line-height: 1.2;
            font-weight: 300;
            margin: 2rem 0 3rem 0;
        }

        input[type="text"],
        input[type="password"],
        input[type="email"] {
            color: #fff;
            background-color: transparent;
            border: none;
            border-bottom: 1px solid #fff;
            padding: 0.2em;
            font-size: 1.4rem;
        }

        button {
            margin-top: 2rem;
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }

        a {
            text-decoration: none;

            &:focus {
                color: #fff;
            }
        }

        .get-login-help {
            color: #ddd;

            h3,
            h4 {
                font-weight: normal;
            }
        }

        .alert {
            text-align: left;
        }
    }

</style>



// WEBPACK FOOTER //
// Login.vue?14acb902